import Vue from 'vue'

export const userStorage = {
  get () {
    return JSON.parse(localStorage['user'] || '{}')
  },

  set (credentials) {
    localStorage['user'] = JSON.stringify(credentials)
  },

  clear () {
    delete localStorage['user']
  }
}

export const auth = {
  current: false,

  login (username, password) {
    if (typeof username === 'undefined') return Promise.reject()
    const credentials = { username, password }
    Vue.http.headers.common['Authorization'] = `Basic ${base64(username, password)}`
    return Vue.http.post('/api/login').then((res) => {
      const {user} = res.body
      userStorage.set(credentials)
      this.current = user
      if (!user.permissions || !user.permissions.length) {
        this.current.permissions = []
      }
    })
  },

  logout () {
    this.current = false
    userStorage.clear()
  },

  isAuthorized (action, restriction) {
    if (this.current === false) return false
    let {admin, permissions} = this.current
    if (admin === true) return true
    restriction = Number(restriction)
    const found = permissions.find(permission => {
      if (!permission[action]) return
      if (typeof permission[action] === 'boolean') {
        return permission[action]
      }
      if (permission[action].length) {
        return permission[action].includes(restriction)
      }
    })
    return !!found
  }
}

function base64 (username, password) {
  const auth = `${username}:${password}`
  return window.btoa(auth)
}

export default auth



// WEBPACK FOOTER //
// ./app/frontend/services/auth.js